import type { Object3D } from "three"

export default function isTooCloseXY(
  x: number,
  y: number,
  items: Array<Object3D>,
  minDist: number): boolean {
  const minDist2 = minDist * minDist
  for (const s of items) {
    const dx = s.position.x - x
    const dy = s.position.y - y
    if (dx * dx + dy * dy < minDist2) return true
  }
  return false
}
